export default __webpack_public_path__ + "static/media/play_icon.cfdd94fa.svg";